// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__SfCXm","notes":"Notes_notes__15FXO"};